import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiJsonFormatterModule } from '@components/ui-json-formatter/ui-json-formatter.module';
import { SharedModule } from '@modules/shared.module';
import { AuditPageComponent } from '@pages/audit/audit.page';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { AuditLogDataModalComponent } from './modals';

const MODALS = [
    AuditLogDataModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiGridModule,
        UiGridResetModule,
        UiJsonFormatterModule,
        UiNgLetModule,
        UiDateFormatModule,
    ],
    declarations: [
        AuditPageComponent,
        ...MODALS,
    ],
    exports: [
        AuditPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class AuditModule { }
